import React from "react";
import { useTranslation } from "react-i18next";
import { Plus, Search } from "lucide-react";
import BlueprintDetailsDialog from "./BlueprintDetailsDialog";

const BlueprintToolbar = () => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = React.useState("");
  const [openCreate, setOpenCreate] = React.useState(false);

  return (
    <div className="mb-6 flex flex-wrap justify-between items-center gap-3">
      <div className="relative flex min-w-[250px] flex-1 items-center md:flex-initial">
        <Search className="absolute start-3 size-4 text-muted-foreground" />
        <input
          className="h-10 w-full rounded-[8px] border border-border bg-card ps-9 pe-3 text-sm text-foreground outline-hidden transition-colors placeholder:text-muted-foreground focus:border-primary"
          type="text"
          value={searchQuery}
          placeholder={t("blueprints.searchBlueprints")}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <button
        type="button"
        onClick={() => {
          setOpenCreate(true);
        }}
        className="flex h-10 items-center gap-2 rounded-[8px] bg-primary px-5 text-sm font-semibold text-primary-foreground transition-all hover:brightness-110"
      >
        <Plus className="size-4" />
        {t("blueprints.CreateNewBlueprint")}
      </button>
      <BlueprintDetailsDialog
        open={openCreate}
        onOpenChange={(open) => {
          setOpenCreate(open);
        }}
      />
    </div>
  );
};

export default BlueprintToolbar;
